// [IMPORT] Sub components
import headerRow  from "./urDataGridHeaderRow.vue";
import feaderRow  from "./urDataGridFeaderRow.vue";// freeze header -> 외부공개시 명칭 이쁘게 바꿀것
import headerCell from "./urDataGridHeaderCell.vue";
import checkCell  from "./urDataGridHeaderCheckCell.vue";

import headerContext from "./module/urDataGridHeaderContext"
import headerConfig  from "./module/urDataGridHeaderConfig.vue"

export default {
    name : 'urDataGridSlotHeader',
    inject : ['gridInfo'],
    computed: {
        // !freezeWidth && gridInfo.opts.selectCheck
        isSelectCheck() {return this.gridInfo.opts.selectCheck}
    },
    mounted() {
        this.gridInfo.func.setRefs('header'      ,this.$refs.gridHeader);
    },
    /* NOSONAR */render(h) {
        var slot = this.gridInfo.slot['header']
        // 1. Build scoped slot.
        // 1.1 get tags
        var scoped = {};
        scoped.gridInfo = this.gridInfo;
        scoped.headers  = this.gridInfo.cols;
        var $slot = slot(scoped);

        // 2. filter only header row & cell - parse slot
        var cells = [], fells = [], rowCnt = 0,
            cols = this.gridInfo.cols, cIdx = 0,
            fIdx = this.gridInfo.vars_freezeCount;
        var ___ppp = new Array(cols.length).fill(0);
        $slot.forEach(vNode => {
            // 2.1 pre-check
            if(!vNode.componentOptions) return;
            var cOpts = vNode.componentOptions,
                name = cOpts.Ctor.options.name;
            if(name === 'urDataGridHeaderRow') {// Use real name in vue file(component);
                // 2.2 New row start.
                // 2.2.1 Pseudo cell for checkbox
                var chs = vNode.componentOptions.children;
                cIdx = 0;
                // 2.2.2 Pseudo cell for checkbox
                if(this.isSelectCheck) {
                    // XXX first row's pseudo cell is changed to real checkbox
                    var checkWidth = this.gridInfo.opts.selectCheckboxWidth;
                    (fIdx>0?fells:cells)
                    .push(h(headerCell, {props:{width:checkWidth, pseudo:true}}));
                }
                // 2.3 loop childrens
                chs.forEach(ch => {
                    // 2.3.1 Childrens... check something. header-cell only
                    var chOps = ch.componentOptions;
                    if(!chOps) {return}
                    var chName = chOps.Ctor.options.name, chProp = chOps.propsData;
                    if(chName !== 'urDataGridHeaderCell') {return}
                    /// 여기서부터 ch는 header-cell 컴포넌트(라 칩시다.)
                    var rSpan = parseInt(chProp.rowspan) || 1,
                        cSpan = parseInt(chProp.colspan) || 1;
                    
                    // 2.3.2 at first prepend pseudo div
                    for(;___ppp[cIdx];cIdx++) {
                        (fIdx>cIdx?fells:cells)
                        .push(h(headerCell, {props:{idx:cIdx, pseudo:true}}))
                        ___ppp[cIdx]--;
                    }
                    // 2.3.3 add 
                    if(rSpan > 1) { // 검색조건 없어도 동작은 동일함.
                        for(var i=cIdx, ii=cIdx+cSpan; i<ii; i++ ){
                            ___ppp[i]+= (rSpan-1);
                        }
                    }
                    // 2.3.4 Add component to array
                    chProp.idx = chProp.idx || cIdx;
                    (fIdx>cIdx?fells:cells).push(ch)
                    // 2.3.x ++cIdx <= goto jail
                    cIdx += cSpan;
                })
                // 2.4 remain space?
                for(; ___ppp[cIdx]; cIdx++) {
                    (fIdx>cIdx?fells:cells)
                    .push(h(headerCell, {props:{idx:cIdx, pseudo:true}}, []))
                    ___ppp[cIdx]--;
                }
                // 2.5 add spliter -> make new line
                cells.push(h('div',{style:{flex:'0 0 100%'}},[]))
                if(fIdx>0) {fells.push(h('div',{style:{flex:'0 0 100%'}},[]))}
                rowCnt++;
            } else if(name === 'urDataGridHeaderCell'){
                // One row mode (I'm on loop)
                cOpts.propsData.idx = cOpts.propsData.idx || cIdx;
                cells.push(vNode);
                cIdx++;
                // TODO one row span
            } else {
                cells.push(vNode);
            }
        })
        // 3. Adjust cells.
        if(this.isSelectCheck) {
            var arr = (fIdx>0?fells:cells);
            arr.shift()
            arr.unshift(h(checkCell, {props:{rowspan:2}}))
        }
        
        
        // x. draw header
        var opts = {
            'directives':[{name:'grid-click-outside',value:this.handler_clickOutside}],
            'staticClass':'ur-data-grid__header',
            'ref':'gridHeader'};
        var childs = [];
        if(this.gridInfo.vars_freezeWidth) {
            childs.push(h(feaderRow, {props:{rowCnt:rowCnt}}, fells));
        }
        childs.push(h(headerRow, {props:{rowCnt:rowCnt}}, cells))
        childs.push(h(headerContext));
        childs.push(h(headerConfig));
        
        return h('div', opts, childs);
    },
    methods : {
        // [METHOD] document click document - click outside
        handler_clickOutside(e) {
            // 1. close header context
            this.gridInfo.func.setHeaderContext(null);
        },
    },
    directives: {
        'grid-click-outside': {
            bind: function(el, binding) {
                // Define Handler and cache it on the element
                const handler = (e) => {
                    if (!(el.contains(e.target) || el === e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                // add Event Listeners
                document.addEventListener('mousedown', handler)
            },
            unbind: function(el, binding) {
                // Remove Event Listeners
                document.removeEventListener('mousedown', el.__vueClickOutside__)
                el.__vueClickOutside__ = null
            }
        }
    }/**/
}
